import { IReportsCampaignResult } from "reports/model"
import { reportsRPO } from "reports/repository"

export async function getCampaignsReports(campaignIds: number[]): Promise<IReportsCampaignResult[]> {
  return reportsRPO.getCampaignsResults(campaignIds)
}
